import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const VenueGallery = ({ images, venueName }: { images: string[]; venueName: string }) => {
  const [current, setCurrent] = useState(0);
  const allImages = images?.length ? images : [];

  if (!allImages.length) return null;

  return (
    <div className="relative overflow-hidden rounded-2xl">
      <img
        src={allImages[current]}
        alt={`${venueName} ${current + 1}`}
        className="aspect-[21/9] w-full object-cover transition-opacity duration-300"
      />
      {allImages.length > 1 && (
        <>
          <button
            onClick={() => setCurrent(i => (i - 1 + allImages.length) % allImages.length)}
            className="absolute left-3 top-1/2 -translate-y-1/2 rounded-full bg-card/80 p-2 text-foreground backdrop-blur hover:bg-card"
          >
            <ChevronLeft className="h-5 w-5" />
          </button>
          <button
            onClick={() => setCurrent(i => (i + 1) % allImages.length)}
            className="absolute right-3 top-1/2 -translate-y-1/2 rounded-full bg-card/80 p-2 text-foreground backdrop-blur hover:bg-card"
          >
            <ChevronRight className="h-5 w-5" />
          </button>
          <div className="absolute bottom-3 left-1/2 flex -translate-x-1/2 gap-1.5">
            {allImages.map((_, i) => (
              <button
                key={i}
                onClick={() => setCurrent(i)}
                className={`h-2 rounded-full transition-all ${i === current ? "w-6 bg-primary" : "w-2 bg-foreground/40"}`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default VenueGallery;
